import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {
  AppointmentDayAvailability,
  AppointmentPreselection,
  AppointmentSlot
} from '../../appointments/model/appointments-models';

@Component({
  selector: 'app-appointment-summary-card',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './appointment-summary-card.component.html',
  styleUrls: ['./appointment-summary-card.component.scss']
})
export class AppointmentSummaryCardComponent {
  @Input() preselection: AppointmentPreselection | null = null;
  @Input() slot: AppointmentSlot | null = null;
  @Input() day: AppointmentDayAvailability | null = null;
  @Input() compact = false;
}
